import { Component, inject } from "@angular/core";
import { RevenueGraphicCardComponent } from "./revenue-graphic-card/revenue-graphic-card.component";
import { RevenueService } from "../../../../../services/revenue.service";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-revenue-graphic-page",
    imports: [CommonModule, RevenueGraphicCardComponent],
    templateUrl: "./revenue-graphic-page.component.html",
    styleUrl: "./revenue-graphic-page.component.scss"
})
export class RevenueGraphicPageComponent {
  private readonly revenueService = inject(RevenueService);

  revenue$ = this.revenueService.getOrganizerRevenue();
}
